import React from 'react';
import '@components/module-components/POSMap/pos-map.scss';
import {translate} from '@src/helpers';
import {useSelector} from "react-redux";
import openLinkIcon from "@assets/images/icons/readmore-blue.svg";

import {ENV} from "@environments/environment";
import VerificationLegendBadge from "@components/VerificationLegend/VerificationLegendBadge";
import {I_POS, VerifiedLabelMarkupProps} from "@components/module-components/POSMap/types";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV

const ContentMarkerUnclaimed: React.FC<VerifiedLabelMarkupProps> = ({poz}: I_POS) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;

  return <li className={"fib-process-markers"} style={{
    cursor: "default",
  }}>
    <div className="fib-process-unclaimed">

      <div className={`d-flex align-items-center mb-1`}

      >

        <span
          className={`fib-process-markers-status process-status-${(poz.claimed_status || "").toLowerCase()}`}
          dangerouslySetInnerHTML={{__html: poz.custom_order}}/>

        <h6 className={"ml-2 mb-0"}>{translate(langData.localize, "LABEL.B2C.PROCESS_UNCLAIMED")}</h6>

        {/*<ProcessClaimStatusBadge claimed_status={poz.claimed_status} className={"ml-3"}/>*/}

        <VerificationLegendBadge status={(poz.claimed_status?.toLocaleUpperCase())} className={"ml-3"}/>

      </div>

      <p>
        {translate(langData.localize, "LABEL.B2C.PROCESS_UNCLAIMED.DESCRIPTION", "", {
          process_name: poz.process_name,
          process_manufacturer_name: poz.process_manufacturer_name,
        })}
      </p>

      <p>
        <a target={"_blank"} rel={"nofollow noopener"}
           href={URL_WEBAPP + "/register"}>{translate(langData.localize, "LABEL.B2C.SIGN_UP")}</a>
        <img src={openLinkIcon} alt=""/>
      </p>
    </div>
  </li>
}

export default ContentMarkerUnclaimed;
